const http = require('../lib/httpClient');
const { getCookie, getChannelId, getEcommId, getXCommerceValue } = require('../lib/browserData');
const { COOKIES, COMMERCE_HEADER } = require('../constants');

const catalystUserStatusError = {
  code: 'CATALYST_USER_STATUS_ERROR',
  message: 'Unable to get user status',
};

const endpoint = '/s/auth/v1/user/status?q=';

async function catalystUserStatus(tenantId, catalystBaseUrl = '', params = 'consents,password') {
  const sessionId = getCookie(COOKIES.SESSION.VALUE);
  if (!sessionId) {
    return {
      errors: [{ code: 'USER_STATUS_ERROR', message: 'Session not found' }],
      data: undefined,
    };
  }
  const result = await http.get(`${catalystBaseUrl}${endpoint}${params}`, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': getEcommId(tenantId),
      'x-commerce': getXCommerceValue(catalystBaseUrl) || COMMERCE_HEADER,
    },
  });

  const { responseBody } = result || {};

  if (!responseBody) return { data: undefined, errors: [catalystUserStatusError] };
  const { errors, passwordRequired, consentRequired } = responseBody;
  if (errors && errors.length > 0) return { data: undefined, errors };
  return { data: { passwordRequired, consentRequired }, errors: [] };
}

module.exports = catalystUserStatus;
